import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=97c5c238&scoped=true&"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=97c5c238&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c5c238",
  null
  
)

export default component.exports